export default __webpack_public_path__ + "static/media/HistoricContact.be822f49.svg";